module.exports = __webpack_public_path__ + "static/fonts/lato-v23-latin-ext_latin-900.3ef75ee.woff";